import { PropertyWithDetails } from ".";
import { executeServiceCall } from "./requests";

export const propertyService = {
  async getAllForShellCommandsUsingApiToken(token: string): Promise<Array<PropertyWithDetails>> {
    return executeServiceCall(
      "./services/FormidableDesigns.Services.V1.PropertyService.GetAllForShellCommandsUsingApiToken",
      JSON.stringify({}),
      token
    );
  }
};

